import React from 'react';
import PropTypes from 'prop-types';
import Switch from './ui/Switch';
import RepeatGroup from './ui/RepeatGroup';

class ProductModalSales extends React.Component{
    render() {
        const previews = this.props.product.categoryPreviews;
        let previewRepeatGroups = [];
        if(previews){ 
            previewRepeatGroups =  Object.keys(previews).map(preview => {
                if(previews[preview]) {
                    return(
                        <RepeatGroup fieldName="Category name" key={preview} id={preview} keyName={previews[preview].catName || ''} value={null} onChange={(id, preview) => this.props.updatePreview('categoryPreviews', id, preview)} onRemove={(id)=> this.props.removePreview('categoryPreviews', id)}/>
                    );
                }
                return null;
            });
        } 

        return (
            <div className="tab-panel">
                <div className="column">
                    <Switch checked={this.props.product.forSale === "true"} label="Product for sale" onChange={checked => this.props.updateProduct("forSale", checked) } />

                    <label>Link to the sales page for this product</label>
                    <input defaultValue={this.props.product.salesPageLink} onChange={e => this.props.updateProduct("salesPageLink", e.target.value)} placeholder="E.g. https://..." />

                    <label>Sales message to show at bottom of preview</label>
                    <input defaultValue={this.props.product.salesMessage} onChange={e => this.props.updateProduct("salesMessage", e.target.value)} placeholder="E.g. Buy now to unlock this product" />

                    <label>Tag to drop if purchase with one-click</label>
                    <input defaultValue={this.props.product.oneClickSaleTag} onChange={e => this.props.updateProduct("oneClickSaleTag", e.target.value)} placeholder="E.g. 1234 or 4567,9876" />
                </div>
                <div className="column">
                    {previewRepeatGroups}
                    <a onClick={e => this.props.addPreview('categoryPreviews')} className="btn-add"><i className="material-icons">add_circle_outline</i>Add new</a>
                </div>
            </div>
        );
    }
}

ProductModalSales.propTypes = {
    product: PropTypes.object.isRequired,
    updateProduct: PropTypes.func.isRequired,
    addPreview: PropTypes.func.isRequired,
    updatePreview: PropTypes.func.isRequired,
    removePreview: PropTypes.func.isRequired
}

export default ProductModalSales;


/** WEBPACK FOOTER **
 ** ./src/components/ProductModalSales.js
 **/